export const arr1 = [
  {
    id: 1,
    image: require("../../../assets/images/B-tech-CSE2.png"),
    heading: "B.Tech Computer Science Engineering",
    para: "Computer science and engineering has revolutionized a world that was there only a moment ago, continues to have unparalleled impact in today's world, and has a steadily increasing scope that is shaping tomorrow's world.",
    moreDetails:
      "/Academics/DepartmentOfComputerScience?course=Btech&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 2,
    image: require("../../../assets/images/IMG_9438.JPG"),
    heading: "B.Tech Data Science",
    para: "Computer Science and Engineering department aims to prepare the young engineers by imparting high quality technical education coupled with appropriate training and wide exposure in form of MOUs, linkages, industry oriented programmes, workshops, expert lectures, etc.",
    moreDetails:
      "/Academics/DepartmentOfComputerScience?course=BtechDS&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 3,
    image: require("../../../assets/images/B-tech-ECE.png"),
    heading: "B.Tech Electronics & Communication Engineering",
    para: "Electronics Engineering drives our world of new technologies. Devices designed by Electronic Engineers feature in all aspects of modern life, including computers, mobile phones, robotics, the internet, digital television, satellites, aerospace, medical scanners, security systems and sustainable energy.",
    moreDetails: "/Academics/DepartmentOfECE?type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 4,
    image: require("../../../assets/images/B-tech-CE.png"),
    heading: "B.Tech Civil Engineering",
    para: "Civil Engineering is the art of directing the great sources of power in nature for the use and convenience of man. It refers to the practice of organizing the design and construction of any artifice which transforms the physical world around us to meet some recognized need.",
    moreDetails:
      "/Academics/DepartmentOfCivilEngineering?course=BtechCivil&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 5,
    image: require("../../../assets/images/IMG_9112 - Copy.JPG"),
    heading: "B.Tech Mechanical Engineering",
    para: "Mechanical Engineering has been the medium through which the single most important socio-economicrevolution known as the Industrial Revolution had found its expression in the 19 th century.",
    moreDetails:
      "/Academics/SchoolOfMechanicalEngineering?course=BtechME&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 6,
    image: require("../../../assets/images/B-tech-cse.png"),
    heading: "B.Tech Artificial Intelligence & Machine Learning",
    para: "B.Tech Artificial Intelligence & Machine Learning course focuses on artificial intelligence and machine learning technologies.It is an ideal course for people who want to use technology to create innovative solutions and make an impact on the world.",
    moreDetails:
      "/Academics/DepartmentOfComputerScience?course=BSCAI&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 7,
    image: require("../../../assets/images/IT_LAB4.jpg"),
    heading: "B.Sc Graphics & Web Designing",
    para: "It is an undergraduate degree discipline that focuses on various aspects of design, such as visual communication, understanding of user experience, elements of composition and color, typography, and coding for web development.",
    moreDetails:
      "/Academics/DepartmentOfComputerScience?course=BSCGraphics&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  // {
  //   id: 8,
  //   image: require("../../../assets/images/Diploma-CE.png"),
  //   heading: "Diploma CE",
  //   para: "The candidate should have qualified 10 or should be a diploma holder. The total number of seats available is 20 for the CE diploma.",
  //   moreDetails:
  //     "/Academics/DepartmentOfCivilEngineering?course=DiplomaCivil&type=Courses",
  //   viewAll: "/academics/listOfCourses",
  // },
  // {
  //   id: 9,
  //   image: require("../../../assets/images/Diploma-CSE.png"),
  //   heading: "Diploma CSE",
  //   para: "The candidate should have qualified 10 or should be a diploma holder. The total number of seats available is 20 for the CSE diploma.",
  //   moreDetails:
  //     "/Academics/DepartmentOfComputerScience?course=DiplomaCSE&type=Courses",
  //   viewAll: "/academics/listOfCourses",
  // },
  {
    id: 10,
    image: require("../../../assets/images/Diploma-ME.png"),
    heading: "Diploma Mechanical Engineering",
    para: "The candidate should have qualified 10 or should be diploma holder. The total number of seats available is 20 for the ME diploma",
    moreDetails:
      "/Academics/SchoolOfMechanicalEngineering?course=DiplomaME&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  // {
  //   id: 11,
  //   image: require("../../../assets/images/MLS_LAB_3_RESIZE.png"),
  //   heading: "B.Sc. MLS",
  //   para: "B.Sc Medical Laboratory Science envisions producing competent professionals equipped with the knowledge and skills to excel in the dynamic field of medical diagnostics. The program aims to foster a deep understanding of laboratory techniques, diagnostic procedures, and medical technologies among students.",
  //   moreDetails:
  //     "/Academics/DepartmentOfHealthScience?course=BscMLS&type=Courses",
  //   viewAll: "/academics/listOfCourses",
  // },
  // {
  //   id: 12,
  //   image: require("../../../assets/images/OT_LAB_1_RESIZE.png"),
  //   style: "text-base",
  //   heading: "B.Sc. Operation  Theatre & Anesthesia",
  //   para: "B.Sc. Operation  Theatre and Anesthesia Science is a three year undergraduate course that provides students with comprehensive knowledge about the equipment, care, principles and practices of anesthesia, operation theatre technique and related sciences.",
  //   moreDetails:
  //     "/Academics/DepartmentOfHealthScience?course=BtechOperational&type=Courses",
  //   viewAll: "/academics/listOfCourses",
  // },
  // {
  //   id: 13,
  //   image: require("../../../assets/images/RIT_LAB_1_RESIZE.png"),
  //   heading: "B.Sc. Radiology and Imaging Technology (RIT)",
  //   para: "B.Sc Radiology & Imaging Technology is a 3-year course in the field of medical sciences and technology. It provides training in the use of X-rays and other forms of radiation for diagnostic and therapeutic purposes.",
  //   moreDetails:
  //     "/Academics/DepartmentOfHealthScience?course=RadiologyTab&type=Courses",
  //   viewAll: "/academics/listOfCourses",
  // },
  {
    id: 14,
    image: require("../../../assets/images/MBA.png"),
    heading: "MBA",
    para: "MBA is an intensive 24 months journey that opens up students mind by bringing them out of comfort zone and completely extending their capabilities. It introduces the student to a new range of skills and tools, which is necessary to manage all kind of business activities.",
    moreDetails: "/Academics/ManagementDepartment?course=MBA&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 15,
    image: require("../../../assets/images/BBA.png"),
    heading: "BBA",
    para: "The objective of Business administration is to organize people and resources in an efficient manner so as to achieve common goals and objectives of a company.",
    moreDetails: "/Academics/ManagementDepartment?course=BBA&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 16,
    image: require("../../../assets/images/BCOM.png"),
    heading: "B.Com (Hons.)",
    para: "The objective of Business administration is to organize people and resources in an efficient manner so as to achieve common goals and objectives of a company. The principles of business administration are of use in an individually run business entity as well as a Fortune 500 company.",
    moreDetails: "/Academics/ManagementDepartment?course=BCOM&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 17,
    image: require("../../../assets/images/IT_LAB3.jpg"),
    heading: "MCA",
    para: "Fast growing information technology and communication systems have become critical components of almost every company’s strategic plan. Companies which want to take advantage of the new information technologies and communication systems require professionals.",
    moreDetails: "/Academics/DepartmentOfIT?course=MCA&&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 18,
    image: require("../../../assets/images/BCA.png"),
    heading: "BCA",
    para: "Fast growing information technology and communication systems have become critical components of almost every company’s strategic plan. Companies which want to take advantage of the new information technologies and communication systems require professionals.",
    moreDetails: "/Academics/DepartmentOfIT?course=BCA&&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 19,
    image: require("../../../assets/images/WhatsApp Image 2022-09-30 at 9.40.09 PM.jpeg"),
    heading: "BHMCT",
    para: "BHMCT is a 4-year (8-Semesters) undergraduate course which aims to impart the modern necessary artifice and attributes required by a passionate student who wishes to develop and enhance skills of guest satisfaction in hospitality sector.",
    moreDetails:
      "/Academics/DepartmentOfHotelManagement?course=BHMCT&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 20,
    image: require("../../../assets/images/Diploma-CSE.png"),
    heading: "B.VOC Software Development",
    para: "B.Voc or Bachelor of Vocational Studies in Software Development is a 3 years undergraduate degree course that aims at improving the skills of the candidates by concentrating on theoretical knowledge as well as practical training.",
    moreDetails:
      "/Academics/DepartmentOfComputerScience?course=BVOCSoftware&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  // {
  //   id: 21,
  //   image: require("../../../assets/images/applied4.jpg"),
  //   heading: "Department Of Applied Science",
  //   para: "Applied science is the application of existing scientific knowledge to practical applications, like technology or inventions.",
  //   moreDetails: "/Academics/DepartmentOfAppliedScience?type=Courses",
  //   viewAll: "/academics/listOfCourses",
  // },
  {
    id: 22,
    image: require("../../../assets/images/hotel3.jpeg"),
    heading: "B.Voc. Hospitality and Catering Management",
    para: "This course carefully takes you through the basics of the food services industry and involves the planning and organization of food and beverage services for various types of events.",
    moreDetails:
      "/Academics/DepartmentOfHotelManagement?course=BVocHospitality&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 23,
    image: require("../../../assets/images/B.Voc.-Auto-mobile.png"),
    heading: "B.Voc Automobile Servicing",
    moreDetails:
      "/Academics/SchoolOfMechanicalEngineering?course=BVOCAutomobile&type=Courses",
    para: "Vocational or skill based education is becoming more significant with the passing time. It is an emerging course in India that aims in providing adequate skills required for a particular trade to candidates.",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 24,
    image: require("../../../assets/images/BSc-OT.png"),
    style: "text-base",
    heading: "M.Sc. Medical Microbiology",
    para: "The vision for a Master of Science (MSc) program in Medical Microbiology may vary depending on the specific goals and objectives of the educational institution offering the program. To be a leading academic program in Medical Microbiology, committed to excellence in education, research, and service, fostering a dynamic and innovative environment that prepares students to address current and emerging challenges in the field of medical microbiology.",
    moreDetails:
      "/Academics/DepartmentOfHealthScience?course=BtechOperational&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 25,
    image: require("../../../assets/images/BCA.png"),
    heading: "B. Voc. Web Technology & Multimedia",
    para: "B.Voc course in Web technology and Multimedia is to address the growing demand for skilled professionals in the digital media industry.",
    moreDetails: "/Academics/DepartmentOfIT?course=BCA&&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 26,
    image: require("../../../assets/images/BSc-OT.png"),
    style: "text-base",
    heading:
      "M.Sc. Medical Technology in Operation Theatre Technology (MTAOTT)",
    para: "The MSc in Anesthesia and Operation Theatre Technology typically aims to provide students with a comprehensive understanding of anesthesia techniques, operation theatre management, patient care, and medical equipment operation. It may cover topics such as anesthesia pharmacology, patient monitoring, surgical procedures, infection control, and emergency response protocols. The course also often includes practical training in anesthesia administration, operation theatre procedures, and equipment handling to prepare students for roles in healthcare settings",
    moreDetails:
      "/Academics/DepartmentOfHealthScience?course=BtechOperational&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  // {
  //   id: 27,
  //   image: require("../../../assets/images/BSc-OT.png"),
  //   style: "text-base",
  //   heading:
  //     "B.Sc. Medical Technology in Operation Theatre Technology (MTAOTT)",
  //   para: "The rationale behind offering a Bachelor of Science (BSc) in Medical Technology with a specialization in Anesthesia and Operation Theatre Technology lies in addressing the specific needs of the healthcare industry, particularly in surgical settings. Anesthesia technologists and operation theatre technicians play critical roles in patient care during surgical interventions. Their expertise in anesthesia administration, patient monitoring, and operation theatre management directly impacts patient. Ensuring patient safety and maintaining high-quality standards in surgical care are paramount.",
  //   moreDetails:
  //     "/Academics/DepartmentOfHealthScience?course=BtechOperational&type=Courses",
  //   viewAll: "/academics/listOfCourses",
  // },

  {
    id: 28,
    image: require("../../../assets/images/MLS_LAB_3_RESIZE.png"),
    heading: "B.Sc. MLS",
    para: "The course rationale for the B.Sc. Medical Laboratory Sciences program at I.K Gujral Punjab Technical University lies in addressing the growing demand for skilled professionals in the field of healthcare diagnostics.",
    moreDetails:
      "/Academics/DepartmentOfHealthScience?course=BscMLS&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 29,
    image: require("../../../assets/images/OT_LAB_1_RESIZE.png"),
    style: "text-base",
    heading:
      "B.Sc. Medical Technology in Operation Theatre Technology (MTAOTT)",
    para: "The rationale behind offering a Bachelor of Science (BSc) in Medical Technology with a specialization in Anesthesia and Operation Theatre Technology lies in addressing the specific needs of the healthcare industry, particularly in surgical settings.",
    moreDetails:
      "/Academics/DepartmentOfHealthScience?course=BtechOperational&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 30,
    image: require("../../../assets/images/RIT_LAB_1_RESIZE.png"),
    heading: "B.Sc. Radiology and Imaging Technology (RIT)",
    para: "Radiography and Imaging Technology is an undergraduate program which mainly focuses on radiology and imaging technology about human anatomy. ",
    moreDetails:
      "/Academics/DepartmentOfHealthScience?course=RadiologyTab&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
  {
    id: 31,
    image: require("../../../assets/images/RIT_LAB_1_RESIZE.png"),
    heading: "M.Sc. Radiology and Imaging Technology",
    para: "The rationale behind an MSc in Radiation and Imaging Technology lies in the increasing demand for skilled professionals in the field of medical imaging, radiation therapy, and radiation safety. This program typically aims to provide students with advanced knowledge and practical skills in areas such as diagnostic imaging techniques, radiation therapy planning and delivery, radiation safety protocols, and emerging technologies in medical imaging. ",
    moreDetails:
      "/Academics/DepartmentOfHealthScience?course=RadiologyTab&type=Courses",
    viewAll: "/academics/listOfCourses",
  },

  {
    id: 32,
    image: require("../../../assets/images/MLS_LAB_3_RESIZE.png"),
    heading: "Bachelor of Nutrition and Dietetics (Honors)",
    para: "Bachelor of Nutrition and Dietetics (Honors) focuses on human nutrition, food science, therapeutic diets, wellness management, and healthy lifestyle practices.",
    moreDetails:
      "/Academics/DepartmentOfHealthScience?course=Nutrition&type=Courses",
    viewAll: "/academics/listOfCourses",
  },

  {
    id: 33,
    image: require("../../../assets/images/RIT_LAB_1_RESIZE.png"),
    heading: "B.Sc. Dialysis Technology",
    para: "B.Sc. Dialysis Technology prepares students in dialysis procedures, renal healthcare systems, patient care, and dialysis equipment management.",
    moreDetails:
      "/Academics/DepartmentOfHealthScience?course=Dialysis&type=Courses",
    viewAll: "/academics/listOfCourses",
  },

  // {
  //   id: 34,
  //   image: require("../../../assets/images/RIT_LAB_1_RESIZE.png"),
  //   heading: "B.Sc. Cardiac Care Technology",
  //   para: "B.Sc. Cardiac Care Technology focuses on cardiac diagnostics, ECG monitoring, emergency cardiac care, and cardiovascular healthcare support systems.",
  //   moreDetails:
  //     "/Academics/DepartmentOfHealthScience?course=Cardiac&type=Courses",
  //   viewAll: "/academics/listOfCourses",
  // },

  {
    id: 35,
    image: require("../../../assets/images/IT_LAB4.jpg"),
    heading: "B.Voc Interior Design",
    para: "B.Voc Interior Design focuses on creative interior planning, CAD, space management, lighting concepts, and modern design techniques.",
    moreDetails:
      "/Academics/DepartmentOfDesign?course=BVOCInterior&type=Courses",
    viewAll: "/academics/listOfCourses",
  },

  {
    id: 36,
    image: require("../../../assets/images/BCA.png"),
    heading: "B.Voc E-Commerce and Digital Marketing",
    para: "B.Voc E-Commerce and Digital Marketing focuses on online business, SEO, digital advertising, branding, content creation, and social media marketing.",
    moreDetails: "/Academics/DepartmentOfIT?course=BVocDigital&type=Courses",
    viewAll: "/academics/listOfCourses",
  },

  {
    id: 37,
    image: require("../../../assets/images/B-tech-ECE.png"),
    heading: "B.Voc Electrical Technician",
    para: "B.Voc Electrical Technician focuses on electrical systems, industrial wiring, maintenance, safety standards, and electrical equipment handling.",
    moreDetails: "/Academics/DepartmentOfECE?course=Electrical&type=Courses",
    viewAll: "/academics/listOfCourses",
  },

  {
    id: 38,
    image: require("../../../assets/images/BBA.png"),
    heading:
      "Bachelor of Management Studies (Airlines, Tourism and Hospitality)",
    para: "This program prepares students for careers in aviation, tourism, hospitality operations, customer relationship management, and travel industries.",
    moreDetails: "/Academics/ManagementDepartment?course=BMS&type=Courses",
    viewAll: "/academics/listOfCourses",
  },

  {
    id: 39,
    image: require("../../../assets/images/MBA.png"),
    heading: "Master in Hospital Administration",
    para: "Master in Hospital Administration focuses on healthcare management, hospital operations, leadership, healthcare systems, and medical administration.",
    moreDetails: "/Academics/DepartmentOfHealthScience?course=MHA&type=Courses",
    viewAll: "/academics/listOfCourses",
  },

  {
    id: 40,
    image: require("../../../assets/images/MBA.png"),
    heading: "B.Pharmacy",
    para: "B.Pharmacy focuses on pharmaceutical sciences, drug formulation, medicinal chemistry, pharmacology, and healthcare applications.",
    moreDetails:
      "/Academics/DepartmentOfPharmacy?course=BPharmacy&type=Courses",
    viewAll: "/academics/listOfCourses",
  },

  {
    id: 41,
    image: require("../../../assets/images/BCA.png"),
    heading: "D.Pharmacy",
    para: "Diploma in Pharmacy provides foundational knowledge in medicines, pharmaceutical sciences, healthcare systems, and pharmacy practices.",
    moreDetails:
      "/Academics/DepartmentOfPharmacy?course=DPharmacy&type=Courses",
    viewAll: "/academics/listOfCourses",
  },
];
